<template>
  <drr
    class="componenteCano"
    :id="ID"
    :x="parseInt(Left)"
    :y="parseInt(Top)"
    :w="parseInt(Width)"
    :h="13"
    :angle="parseInt(Angle)"
    :aspectRatio="false"
    :z="0"
    :selectable="Enabled"
    v-on:resizestop="resize"
    v-on:dragstop="drag"
    v-on:rotatestop="rotate"
  >
    <div class="cano" v-if="Res > 0">
      <div class="waterCano" :style="`width: 100%;`">
        <div class="bubbleAreaCano">
          <span class="bubbleCano">
            <span class="glowCano"> </span>
          </span>
          <span class="bubble2Cano">
            <span class="glowCano"> </span>
          </span>
          <span class="bubble3Cano">
            <span class="glowCano"> </span>
          </span>
        </div>
      </div>
    </div>
    <div class="cano" v-else>
      <div class="waterCano" :style="`width: 0%;`"></div>
    </div>
    <!-- <p>{{ Nome }}</p> -->
  </drr>
</template>

<script>
import drr from "@minogin/vue-drag-resize-rotate";
import datas from "../services/datas";
export default {
  /* eslint no-console: ["error", { allow: ["info", "warn", "error"] }] */
  name: "Cano",
  components: {
    drr
  },
  props: {
    ID: { type: String, default: "0", required: true },
    Res: { type: String, default: "0" },
    Nome: { type: String, default: "0" },
    Top: { type: String, default: "0" },
    Left: { type: String, default: "0" },
    Width: { type: String, default: "0" },
    Angle: { type: String, default: "0" },
    Height: { type: String, default: "0" },
    Enabled: { type: Boolean, default: false }
  },
  methods: {
    rotate(pos) {
      let id = this.ID;
      if (Math.abs(pos.angle) >= 0 && Math.abs(pos.angle) < 45) pos.angle = 0;
      else if (Math.abs(pos.angle) >= 45 && Math.abs(pos.angle) < 90)
        pos.angle = 90;
      else if (Math.abs(pos.angle) >= 90 && Math.abs(pos.angle) < 180)
        pos.angle = 180;
      else if (Math.abs(pos.angle) >= 180 && Math.abs(pos.angle) < 360)
        pos.angle = 270;
      let el = document.getElementById(`${this.ID}`);
      el.style.transform = `rotate(${pos.angle}deg)`;
      datas
        .salvarAngulo(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | ANGLE: ${pos.angle} | TOP: ${pos.y} | LEFT: ${pos.x} | HEIGTH: ${pos.h} | WIDTH: ${pos.w}`,
            "rotate"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Rotate!\n${error}`);
        });
    },
    resize(pos) {
      let id = this.ID;
      pos.h = 13;
      let el = document.getElementById(`${this.ID}`);
      el.style.height = `${pos.h}px`;
      datas
        .salvarTamanho(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | HEIGHT: ${pos.h} | WIDTH: ${pos.w} | ANGLE: ${pos.angle}`,
            "resize"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Resize!\n${error}`);
        });
    },
    drag(pos) {
      let id = this.ID;
      datas
        .salvarPosicao(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | TOP: ${pos.y} | LEFT: ${pos.x} | ANGLE: ${pos.angle}`,
            "drag"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Drag!\n${error}`);
        });
    }
  }
};
</script>

<style scoped>
.componenteCano {
  width: 100px;
  height: 13px;
  position: absolute;
  cursor: move;
}
.cano {
  width: 100%;
  height: 100%;
  border: 1px solid black;
  /* border-top: 1px solid black; */
  border-radius: 2px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  background-position: top right;
  background-repeat: repeat-x;
  z-index: -100;
}
.waterCano {
  width: 100%;
  height: 100%;
  /* background-color: skyblue; */
  position: absolute;
  bottom: 0;
  z-index: -100;
}
.waterCano {
  /* background-image: url("../assets/waves.png"); */
  background-color: #9cc6ff;
  background-position: top right;
  position: absolute;
  bottom: 0px;
  width: 80%;
  -webkit-transition: all 3s ease-out;
  -moz-transition: all 3s ease-out;
  transition: all 3s ease-out;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 2px;
  /* z-index: -1000; */
}
.bubbleAreaCano {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
}

/* SASS */
/* BEAKER AND BUBBLES */
@-webkit-keyframes bluePulseCano {
  from {
    -webkit-box-shadow: 0 0 30px #54a9ed;
  }
  50% {
    -webkit-box-shadow: 0 0 80px #69abdf;
  }
  to {
    -webkit-box-shadow: 0 0 30px #54a9ed;
  }
}

@keyframes bubbleFloatCano1 {
  from {
    right: 89%;
    transform: scale(0.9);
    opacity: 0;
    animation-timing-function: ease-in-out;
  }
  1% {
    left: 10%;
    transform: scale(0.3);
    opacity: 0;
    animation-timing-function: ease-in-out;
  }
  30% {
    left: 20%;
    transform: scale(0.8);
    opacity: 1;
    animation-timing-function: ease-in-out;
  }
  95% {
    left: 85%;
    transform: scale(0.3);
    opacity: 1;
    animation-timing-function: ease-in-out;
  }
  99% {
    left: 80%;
    transform: scale(1);
    opacity: 0;
    animation-timing-function: ease-in-out;
  }
  to {
    left: 0%;
    transform: scale(0);
    opacity: 0;
    animation-timing-function: ease-in-out;
  }
}

.bubbleArea span.glow {
  width: 10%;
  height: 10%;
  position: relative;
  display: block;
  border-radius: 200px;
  animation-name: bluePulseCano;
  -webkit-animation-name: bluePulseCano;
  -moz-animation-name: bluePulseCano;
  -o-animation-name: bluePulseCano;
  animation-duration: 2s;
  -webkit-animation-duration: 2s;
  -moz-animation-duration: 2s;
  -o-animation-duration: 2s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
}

.bubbleAreaCano span.bubbleCano {
  display: block;
  position: relative;
  background: #fff;
  background: -moz-radial-gradient(
    center,
    ellipse cover,
    rgba(43, 54, 63, 0.2) 0%,
    #54a9ed 100%
  );
  /* FF3.6+ */
  background: -webkit-gradient(
    radial,
    center center,
    0px,
    center center,
    100%,
    color-stop(0%, rgba(105, 171, 223, 0.2)),
    color-stop(100%, #54a9ed)
  );
  /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Opera 12+ */
  background: -ms-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* IE10+ */
  background: radial-gradient(
    ellipse at center,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#3369abdf", endColorstr="#54a9ed",GradientType=1 );
  /* IE6-9 fallback on horizontal gradient */
  width: 10px;
  height: 10px;
  border-radius: 100%;
  bottom: 5%;
  position: relative;
  animation-name: bubbleFloatCano1;
  -webkit-animation-name: bubbleFloatCano1;
  -moz-animation-name: bubbleFloatCano1;
  -o-animation-name: bubbleFloatCano1;
  animation-duration: 5s;
  -webkit-animation-duration: 5s;
  -moz-animation-duration: 5s;
  -o-animation-duration: 5s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
}

.bubbleAreaCano span.bubble2Cano {
  display: block;
  position: relative;
  background: #fff;
  background: -moz-radial-gradient(
    center,
    ellipse cover,
    rgba(43, 54, 63, 0.2) 0%,
    #54a9ed 100%
  );
  /* FF3.6+ */
  background: -webkit-gradient(
    radial,
    center center,
    0px,
    center center,
    100%,
    color-stop(0%, rgba(105, 171, 223, 0.2)),
    color-stop(100%, #54a9ed)
  );
  /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Opera 12+ */
  background: -ms-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* IE10+ */
  background: radial-gradient(
    ellipse at center,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#3369abdf", endColorstr="#54a9ed",GradientType=1 );
  /* IE6-9 fallback on horizontal gradient */
  width: 4px;
  height: 4px;
  bottom: 70%;
  border-radius: 200px;
  position: relative;
  animation-name: bubbleFloatCano1;
  -webkit-animation-name: bubbleFloatCano1;
  -moz-animation-name: bubbleFloatCano1;
  -o-animation-name: bubbleFloatCano1;
  animation-duration: 4.8s;
  -webkit-animation-duration: 4.8s;
  -moz-animation-duration: 4.8s;
  -o-animation-duration: 4.8s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
}

.bubbleAreaCano span.bubble3Cano {
  display: block;
  position: relative;
  background: #fff;
  background: -moz-radial-gradient(
    center,
    ellipse cover,
    rgba(43, 54, 63, 0.2) 0%,
    #54a9ed 100%
  );
  /* FF3.6+ */
  background: -webkit-gradient(
    radial,
    center center,
    0px,
    center center,
    100%,
    color-stop(0%, rgba(105, 171, 223, 0.2)),
    color-stop(100%, #54a9ed)
  );
  /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Opera 12+ */
  background: -ms-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* IE10+ */
  background: radial-gradient(
    ellipse at center,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#3369abdf", endColorstr="#54a9ed",GradientType=1 );
  /* IE6-9 fallback on horizontal gradient */
  bottom: 70%;
  width: 5px;
  height: 5px;
  border-radius: 200px;
  position: relative;
  animation-name: bubbleFloatCano1;
  -webkit-animation-name: bubbleFloatCano1;
  -moz-animation-name: bubbleFloatCano1;
  -o-animation-name: bubbleFloatCano1;
  animation-duration: 3.5s;
  -webkit-animation-duration: 3.5s;
  -moz-animation-duration: 2.5s;
  -o-animation-duration: 3.5s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
}
</style>
